<template>
  <div class="content-section">
    <progress-bar :currentStep="3"></progress-bar>

    <absa-pay-logo />

    <div class="auth-header">
      <h3>Check your Absa app now to approve payment</h3>
    </div>

    <div>
      <ApprovalTimer
        :duration="60 * 1000"
        :approvalId="transactionId"
        @timeout="handleTimeout"
      />
    </div>

    <div class="list-container">
      <div class="list-item instructions-container">
        <div class="instructions">
          <div class="list-item">
            <img src="../assets/images/absa-logo.svg" alt="absa-logo" />
            <span>Open your <strong>Absa app</strong></span>
          </div>
          <div class="list-item">
            <img src="../assets/images/check-square.svg" alt="check-square" />
            <span>Tap View, then <strong>Approve</strong></span>
          </div>
          <div class="list-item">
            <img
              src="../assets/images/undo-left-square.svg"
              alt="undo-left-square"
            />
            <span><strong>Return</strong> to this screen</span>
          </div>
        </div>
      </div>

      <div class="list-item mobile-button-container">
        <a href="absabankingappurlscheme://" target="_top">Open Absa App</a>
      </div>

      <div class="notification">
        <p class="note">
          <span><img src="../assets/images/info.svg" alt="info" /></span> Please
          note
        </p>
        <p class="disclaimer">
          Once the payment is processed, it is non-reversible. For queries
          regarding your purchase please contact the merchant directly.
        </p>
        <p class="disclaimer" style="padding-bottom: 15px">
          Absa will temporarily provide your account number to Payfast by
          Network for refund purposes.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import ProgressBar from '@/components/ProgressBar.vue'
import AbsaPayLogo from '@/components/AbsaPayLogo.vue'
import ApprovalTimer from '@/components/ApprovalTimer.vue'
import Constants from '@/constants'
import { mapActions } from 'vuex'
import { cancelTransaction } from '@/services/transactionService'

export default {
  name: 'AbsaBankAuthScreen',
  components: { ProgressBar, AbsaPayLogo, ApprovalTimer },
  computed: {
    transactionId() {
      return this.$route.query.transactionId
    },
  },
  methods: {
    ...mapActions('appSettings', ['setError']),
    async handleTimeout() {
      this.$logInfo({
        transactionId: this.transactionId,
        message: Constants.logMessages.approvalTimerExpired,
      })

      await this.cancelBankApiTransaction()
    },
    async cancelBankApiTransaction() {
      this.$logInfo({
        transactionId: this.transactionId,
        message: Constants.logMessages.cancelTransaction,
      })

      const transactionId = this.transactionId

      try {
        await cancelTransaction({
          transactionId,
          reasonCode: 200, // ValidationTimeout
        })
      } catch (e) {
        this.$logInfo({
          transactionId,
          message: `${Constants.logMessages.cancelTransactionFailed}. Error: ${e.message}`,
        })
        console.error(e)
        await this.$router.replace({ name: 'error', query: { transactionId } })
        return
      }

      this.setError('Your Absa authentication has timed out.')
      await this.$router.replace({
        name: 'cancelled',
        query: { transactionId },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.content-section {
  h3 {
    color: #0a0908;
    font-weight: 700;
    font-size: 20px;
  }
}

.notification {
  margin: 50px auto;
  text-align: center;
  border-radius: 8px;
  background: #fbfafa;
  padding: 1px 20px;

  .note {
    font-weight: 700;
  }

  .disclaimer {
    font-size: 12px;
  }
}

.auth-header {
  text-align: center;
  padding: 10px;
  font-size: 20px;
  font-weight: bold;
  max-width: 400px;
  margin: 0 auto;
}

.content-section {
  max-width: 500px;
  margin: 0 auto;
}

.instructions-container {
  justify-content: center;
  margin-top: 30px;

  .instructions {
    display: flex;
    flex-direction: column;
    gap: 20px;

    .list-item {
      margin-bottom: 0;
    }
  }
}

.list-item {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 30px;

  span {
    color: #0a0908;
    font-size: 14px;
  }

  svg {
    width: 15px;
    height: 20px;
  }
}

.mobile-button-container {
  display: none;
  margin-top: 40px;
  justify-content: center;

  a {
    text-decoration: none;
    border-radius: 4px;
    padding: 16px 40px;
    background: #051d43;
    color: #ffffff;
    font-weight: bold;
    font-size: 14px;
    cursor: pointer;
  }
}

@media (max-width: $mobile-resolution) {
  .mobile-button-container {
    display: flex;
  }
}
</style>
